<!-- <p>app-config works!</p>-->
<ng-template #PageLoadingTemplate>
    <app-loading-template DisplayText="Please wait while we load site configuration" />
</ng-template>
<!-- Add a SideNav Dock Page -->
<app-dock-content *ngIf="appSettings && appConfig else PageLoadingTemplate">
    <ng-template #navbar class="alignRow">
        <h1>{{qApplication}} - ({{qEnvironment}}) - Configuration</h1>
    </ng-template>
    <ng-template #content>
        <div class=" application-configuration">
            <div class="configuration-layout">

                <aside class="configuration-sidebar">
                    <div class="sidebar-title">Configuration Sections:</div>
                    <ejs-treeview [fields]="configurationTreeFields"
                        (nodeSelected)="onConfigurationSectionSelected($event)">
                    </ejs-treeview>
                    <button mat-stroked-button type="button" (click)="cancel()"
                        [disabled]="!hasPendingChanges() || saving">
                        Cancel
                    </button>
                    <button mat-flat-button color="primary" type="button" (click)="save()"
                        [disabled]="!hasPendingChanges() || saving">
                        <mat-spinner *ngIf="saving" diameter="20" />
                        <span>{{saving ? 'Saving...': 'Save'}}</span>
                    </button>
                </aside>
                
                <div class="configuration-content">

                    <section id="tos">
                        <!-- Terms of Service card -->
                        <mat-card class="configuration-card" [ngClass]="{'has-changed': hasToSChanges()}">
                            <mat-card-header>
                                <mat-card-title>Terms of Service</mat-card-title>
                                <mat-card-subtitle>
                                    PRISMPdM User Agreement and Privacy Policy
                                </mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>

                                <div class="agreements-row">
                                    <div class="configuration-section">

                                        <mat-slide-toggle color="primary" [(ngModel)]="appConfig.ToS.check">
                                            Check User has accepted
                                        </mat-slide-toggle>

                                        <div class="setting-description">
                                            Ensure users have agreed to the site Terms of Service
                                        </div>

                                    </div>
                                    <div class="configuration-section">

                                        <mat-form-field appearance="outline">
                                            <mat-label>Agreement Version</mat-label>
                                            <input matInput type="number" min="1" step="1"
                                                [(ngModel)]="appConfig.ToS.version">
                                        </mat-form-field>

                                        <div class="setting-description">
                                            Increment this version when the agreements change.
                                            Users will be required to accept the updated agreement.
                                        </div>

                                    </div>
                                </div>

                                <div class="configuration-section">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Agreement Location</mat-label>
                                        <input matInput type="text" [(ngModel)]="appConfig.ToS.link">
                                    </mat-form-field>

                                    <div class="setting-description">
                                        Location of the Terms of Service
                                    </div>

                                </div>
                            </mat-card-content>

                        </mat-card>
                        <hr>
                    </section>

                    <section id="maintenance">
                        <!-- Maintenance card -->
                        <mat-card class="configuration-card" [ngClass]="{'has-changed': hasMaintenanceChanges()}">

                            <mat-card-header>
                                <mat-card-title>Maintenance</mat-card-title>
                                <mat-card-subtitle>
                                    Control when the application is placed into maintenance mode.
                                </mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>

                                <div class="configuration-section">

                                    <mat-slide-toggle color="primary" [(ngModel)]="appConfig.maintenance.enabled">
                                        Enable maintenance mode
                                    </mat-slide-toggle>

                                    <div class="setting-description">
                                        When enabled, users will be shown the maintenance page
                                        during the configured maintenance period.
                                    </div>

                                </div>

                                <div class="configuration-section">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Maintenance message</mat-label>
                                        <textarea matInput rows="2" [(ngModel)]="appConfig.maintenance.message">

                                        </textarea>
                                    </mat-form-field>
                                </div>

                                <div class="date-row">

                                    <div class="date-field">

                                        <div class="date-label">Start</div>

                                        <ejs-datetimepicker placeholder="Maintenance Start Date" [firstDayOfWeek]="1"
                                            format="dd-MMM-yyyy HH:mm" [dayHeaderFormat]="'Abbreviated'"
                                            [value]="getDateTimeLocal(appConfig.maintenance.start)"
                                            (change)="setStartDateSF($event)">
                                        </ejs-datetimepicker>

                                        <div class="date-error" *ngIf="startDateInvalid">
                                            Maintenance start time in the past.
                                        </div>

                                    </div>

                                    <div class="date-field">

                                        <div class="date-label">End</div>

                                        <ejs-datetimepicker placeholder="Maintenance End Date" [firstDayOfWeek]="1"
                                            format="dd-MMM-yyyy HH:mm" [dayHeaderFormat]="'Abbreviated'"
                                            [value]="getDateTimeLocal(appConfig.maintenance.end)"
                                            (change)="setEndDateSF($event)">
                                        </ejs-datetimepicker>

                                        <div class="date-error" *ngIf="endDateInvalid">
                                            Check the Start is before End.
                                        </div>

                                    </div>

                                </div>

                            </mat-card-content>

                        </mat-card>
                        <hr>
                    </section>

                    <section id="deployment">
                        <!-- Deployment card -->
                        <mat-card class="configuration-card" [ngClass]="{'has-changed': hasDeploymentChanges()}">
                            @if (originalappSettings) {
                            <mat-card-header>
                                <mat-card-title>Deployment</mat-card-title>
                                <mat-card-subtitle>
                                    Configure application deployment behaviour.
                                </mat-card-subtitle>
                            </mat-card-header>
                            }
                            <mat-card-content>

                                @if (originalappSettings) {
                                <div class="configuration-section">
                                    <mat-slide-toggle color="primary" [(ngModel)]="appConfig.deployment.silent">
                                        Silent deployment
                                    </mat-slide-toggle>

                                    <div class="setting-description">
                                        Prevent deployment notifications from being displayed
                                        to users.
                                    </div>

                                </div>
                                }
                            </mat-card-content>

                        </mat-card>
                        <hr>
                    </section>
                    
                </div>

            </div>
        </div>
    </ng-template>
</app-dock-content>